/*
 * Copyright: Infosim GmbH & Co. KG Copyright (c) 2000-2021
 * Company: Infosim GmbH & Co. KG,
 *                  Landsteinerstraße 4,
 *                  97074 Wuerzburg, Germany
 *                  www.infosim.net
 */
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { environment } from '../environments/environment';

declare let gtag: (s1: string, s2: string, s3: any) => void;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService implements OnDestroy {
  private search = new Subject<string>();
  private documents = new Subject<string>();
  private unsubscribe = new Subject<void>();

  constructor() {
    if (environment.googleAnalytics) {
      // only track sites where the user remains for at least 4 seconds
      this.documents.pipe(takeUntil(this.unsubscribe), debounceTime(4000)).subscribe((id) => {
        if (id !== '') {
          gtag('event', 'select_content', {
            eventLabel: id,
          });
        }
      });

      this.search.pipe(takeUntil(this.unsubscribe), debounceTime(1000)).subscribe((query) => {
        if (query !== '') {
          gtag('event', 'search', {
            eventLabel: query,
          });
        }
      });
    }
  }

  newSearch(query: string) {
    this.search.next(query);
  }

  newDocument(id: string) {
    this.documents.next(id);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.search.complete();
    this.documents.complete();
  }
}
